import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { ReactLenis } from "lenis/react";
import { Toaster } from "@/components/ui/sonner";
import { Nav } from "@/components/Nav";
import { Footer } from "@/components/Footer";
import Home from "@/pages/Home";
import Report from "@/pages/Report";
import Contact from "@/pages/Contact";
import EmailCheck from "@/pages/EmailCheck";
import EuSellThrough from "@/pages/EuSellThrough";

const TITLES = {
  "/": "EY TECH LLC",
  "/report": "Website Issue Report — EY TECH LLC",
  "/email-check": "Email Delivery Check — EY TECH LLC",
  "/eu-sell-through": "EU Sell-Through Pack — EY TECH LLC",
  "/contact": "Contact — EY TECH LLC",
};

const ScrollToTop = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "instant" });
    document.title = TITLES[pathname] || "EY TECH LLC";
  }, [pathname]);
  return null;
};

function App() {
  return (
    <div className="App bg-cream">
      <ReactLenis root options={{ lerp: 0.08, duration: 1.2 }}>
        <BrowserRouter>
          <ScrollToTop />
          <Nav />
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/report" element={<Report />} />
            <Route path="/email-check" element={<EmailCheck />} />
            <Route path="/eu-sell-through" element={<EuSellThrough />} />
            <Route path="/contact" element={<Contact />} />
          </Routes>
          <Footer />
          <Toaster position="top-center" richColors />
        </BrowserRouter>
      </ReactLenis>
    </div>
  );
}

export default App;
